<template>
	<div>

	</div>
</template>

<script>
import {
		mapState,
		mapActions
	} from 'vuex';

	export default {
		data() {
			return {}
		},
		components: {},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				DDNS: state => state.DDNS,
				httpImg: state => state.httpImg
			}),
		},
		watch: {
			DDNS: {
				handler(val) {
					if (window.location.href.indexOf('localhost') >= 0) {
						this.$router.push({
							name: 'Invitation'
						})

					} else {
						if (val && val['download-new'] && val['download-new'][0]) {
							let https = val['download-new'][0]
							https = https + `/#/pages/other/download?language=${localStorage.getItem('bigLang') || 'CHINESE'}`
							// console.log(777, https)
							window.location.href = https
						}
					}
				},
				immediate: true,
				deep: true
			}
		},
		mounted() {
			

		},
		methods: {}
	}
</script>

<style lang='less'>
</style>